import React from "react";
import { GET } from "../../../../../utils/fetcher";
import { useSelector } from "react-redux";

const cashedChecklists = new Map();

const useChecklistsInfo = () => {
	const organization = useSelector(
		({ organization }) => organization.organization
	);

	const getCheckList = React.useCallback(
		async id => {
			try {
				return (await GET(
					`/bo/organizers/${organization.id()}/checkpoints/${id}`
				)).data;
			} catch (e) {
				console.log(e);
			}
		},
		[organization]
	);

	const getCheckLists = React.useCallback(
		checkLists => {
			return Promise.all(
				checkLists.map(id => {
					return new Promise((resolve, reject) => {
						if (cashedChecklists.has(id)) {
							resolve(cashedChecklists.get(id));
						} else {
							getCheckList(id)
								.then(res => {
									cashedChecklists.set(id, res);
									resolve(res);
								})
								.catch(reject);
						}
					});
				})
			);
		},
		[getCheckList]
	);

	return { getCheckLists };
};

export default useChecklistsInfo;
